import React, { memo } from 'react'

import { Button, Icon, ArrowLeft } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import Composer from 'Pods/ThreeDStudio/Shared/Composer/Composer'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

import MaskCanvas from './Components/Canvas/MaskCanvas'
import Toolbar from './Components/Toolbar/Toolbar'
import useEditCanvas from './useEditCanvas'

const applyIcon = <Icon svgComponent={ArrowLeft} size={iconSize} notSpaced />

// Holds the live editing session. Remounted (via the key in EditTab) whenever a
// new image is loaded, so its seeded state resets cleanly; stays mounted across
// tab switches so the work is preserved.
function EditCanvas() {
  const t = useTranslation()
  const {
    canvas,
    currentImage,
    versions,
    prompt,
    attachments,
    isHistoryOpen,
    isSending,
    isSendDisabled,
    isUploadDisabled,
    fileInputRef,
    handlePromptChange,
    handleUploadClick,
    handleRemoveAttachment,
    handleFilesChange,
    handleSend,
    handleToggleHistory,
    handleCloseHistory,
    handleSelectVersion,
    handleApply,
  } = useEditCanvas()

  return (
    <div className="image-assistant-edit-tab__edit">
      <div className="image-assistant-edit-tab__edit-scroll">
        <div className="image-assistant-edit-tab__canvas-card">
          <Toolbar
            canUndo={canvas.canUndo}
            canRedo={canvas.canRedo}
            isErasing={canvas.isErasing}
            brushSize={canvas.brushSize}
            versions={versions}
            currentId={currentImage?.id}
            isHistoryOpen={isHistoryOpen}
            isSending={isSending}
            onUndo={canvas.undo}
            onRedo={canvas.redo}
            onToggleEraser={canvas.toggleEraser}
            onBrushSizeChange={canvas.setBrushSize}
            onToggleHistory={handleToggleHistory}
            onSelectVersion={handleSelectVersion}
            onCloseHistory={handleCloseHistory}
          />
          <MaskCanvas
            image={currentImage}
            canvasRef={canvas.canvasRef}
            containerRef={canvas.containerRef}
            brushSize={canvas.brushSize}
            isErasing={canvas.isErasing}
            isSending={isSending}
            onPointerDown={canvas.handlePointerDown}
            onPointerMove={canvas.handlePointerMove}
            onPointerUp={canvas.handlePointerUp}
          />
        </div>
        <div className="image-assistant-edit-tab__apply">
          <Button
            type="secondary"
            size="small"
            variant="with-icon"
            actionType="button"
            customClass="image-assistant-panel__action"
            icon={applyIcon}
            disabled={isSending}
            onClick={handleApply}
          >
            {t('imageAssistantPanel.actions.applyAndContinue')}
          </Button>
        </div>
      </div>
      <Composer
        prompt={prompt}
        attachments={attachments}
        tags={EMPTY_ARRAY}
        fileInputRef={fileInputRef}
        isSendDisabled={isSendDisabled}
        isUploadDisabled={isUploadDisabled}
        onPromptChange={handlePromptChange}
        onTagClick={NOOP}
        onUploadClick={handleUploadClick}
        onRemoveAttachment={handleRemoveAttachment}
        onFilesChange={handleFilesChange}
        onSend={handleSend}
      />
    </div>
  )
}

export default memo(EditCanvas)
